import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import toast from "react-hot-toast";

import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { FormCard, FormGrid } from "../../components/FormCard";
import { InputRow, TextAreaRow } from "../../components/Rows";
import { useAuth } from "../../providers/AuthContext";
import { getAppPushMessage } from "../../api/AppPush";

const AppPushDetailPage = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const { getAccessToken } = useAuth();
    const navigate = useNavigate();
    const [row, setRow] = useState(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const token = await getAccessToken();
                const data = await getAppPushMessage(id, token);
                if (!cancelled) {
                    setRow(data);
                }
            } catch (err) {
                toast.error(err?.message || t("toast.failedFetch", { entity: t("nav.appPush") }));
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [id, getAccessToken, t]);

    return (
        <>
            <HeaderBar />
            <div className="flex flex-row w-full">
                <Sidebar />
                <main className="page">
                    <div className="page-content">
                        <div className="flex flex-row items-center pb-4">
                            <button onClick={() => navigate("/app-push")} className="text-black flex">
                                <FontAwesomeIcon icon={faArrowLeft} className="w-4 pr-4" />
                            </button>
                            <h2 className="border-l border-mute-200 pl-4">{t("appPush.detail")}</h2>
                        </div>
                        {row ? (
                            <FormCard title={row.title}>
                                <FormGrid>
                                    <InputRow label={t("appPush.title")} value={row.title} disabled />
                                    <InputRow
                                        label={t("appPush.target")}
                                        value={t(`appPush.targets.${row.targetType}`, { defaultValue: row.targetType })}
                                        disabled
                                    />
                                    <InputRow label={t("common.status")} value={row.status} disabled />
                                    <InputRow label={t("appPush.sender")} value={row.createdByName || "—"} disabled />
                                    <InputRow
                                        label={t("appPush.recipients")}
                                        value={String(row.recipientCount ?? 0)}
                                        disabled
                                    />
                                    <InputRow
                                        label={t("appPush.failed")}
                                        value={String(row.failedCount ?? 0)}
                                        disabled
                                    />
                                    <TextAreaRow label={t("appPush.body")} value={row.body} rows={6} disabled />
                                </FormGrid>
                            </FormCard>
                        ) : null}
                    </div>
                </main>
            </div>
        </>
    );
};

export default AppPushDetailPage;
